import { render, staticRenderFns } from "./edit-exam-form-modal.vue?vue&type=template&id=022e75d0&scoped=true"
import script from "./edit-exam-form-modal.vue?vue&type=script&lang=ts"
export * from "./edit-exam-form-modal.vue?vue&type=script&lang=ts"
import style0 from "./edit-exam-form-modal.vue?vue&type=style&index=0&id=022e75d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e75d0",
  null
  
)

export default component.exports